import { Body, Controller, Delete, Get, HttpCode, Param, Post, Req, UseGuards } from '@nestjs/common';
import {
  ApiBearerAuth,
  ApiBody,
  ApiOperation,
  ApiParam,
  ApiResponse,
  ApiSecurity,
  ApiTags,
} from '@nestjs/swagger';
import { AddWishlistItemRequest, WishlistItemSummary, WishlistResponse } from '@cart/shared-types';
import { AuthenticatedRequest, AuthGuard } from '../auth/auth.guard';
import { WishlistService } from './wishlist.service';

@ApiTags('Wishlist')
@ApiBearerAuth()
@ApiSecurity('store-id')
@Controller('wishlist')
@UseGuards(AuthGuard)
export class WishlistController {
  constructor(private readonly wishlistService: WishlistService) {}

  @Get()
  @ApiOperation({ summary: 'List wishlist items for the current user' })
  @ApiResponse({ status: 200, description: 'Returns wishlist with products' })
  list(@Req() request: AuthenticatedRequest): Promise<WishlistResponse> {
    return this.wishlistService.list(request.user?.id ?? '');
  }

  @Post()
  @ApiOperation({ summary: 'Add a product to the wishlist' })
  @ApiBody({
    schema: {
      type: 'object',
      required: ['productId'],
      properties: {
        productId: { type: 'string', example: 'clx1234abcd' },
      },
    },
  })
  @ApiResponse({ status: 201, description: 'Product added to wishlist' })
  @ApiResponse({ status: 404, description: 'Product not found' })
  add(
    @Req() request: AuthenticatedRequest,
    @Body() body: AddWishlistItemRequest
  ): Promise<WishlistItemSummary> {
    return this.wishlistService.add(request.user?.id ?? '', body);
  }

  @Delete(':id')
  @HttpCode(204)
  @ApiOperation({ summary: 'Remove an item from the wishlist' })
  @ApiParam({ name: 'id', description: 'Wishlist item id' })
  @ApiResponse({ status: 204, description: 'Item removed' })
  @ApiResponse({ status: 404, description: 'Wishlist item not found' })
  delete(@Req() request: AuthenticatedRequest, @Param('id') itemId: string): Promise<void> {
    return this.wishlistService.delete(request.user?.id ?? '', itemId);
  }
}
